<template>
  <div id="backdateAttendance" class=" ">
    <div class="container admin-wrap">
      <div class="row header mb-5">
        <div class="col-lg-5">
          <h3 class="text-left mb-3">{{ lang('Backdate Attendance') }}</h3>
        </div>
        <div class="col-lg-7">
          <div class="row searchingArea">
            <div class="col-lg-12">
              <el-date-picker
                v-model="selectedDate"
                type="date"
                :placeholder="lang('Select Date')"
                format="dd/MM/yyyy"
                value-format="dd/MM/yyyy"
                :picker-options="inputAdvanceClassAttendanceFromToDatePickerOptions"
                @change="clearData()"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="row searchingArea attendance-search">
            <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select" @change="Load()" style="margin-left: auto !important">
              <el-option v-for="item in ddlClassList" :key="item.ClassID" :label="item.ClassName" :value="item.ClassID"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="studentList.length < 1">
          <strong v-if="hideStudentList === false">
            {{ lang('Please select Class...') }}
          </strong>
          <strong v-if="hideStudentList === true">
            {{ lang('No Student Found...') }}
          </strong>
          <img src="../assets/attendance.jpg" />
        </div>
        <div v-if="studentList.length > 0" class="responsive-table">
          <div class="divSortBy">
            <label>Sort By</label>
            <el-select v-model="sortOptionsSelected" @change="changeSort()" placeholder="Sort By" class="pro-edt-select">
              <el-option v-for="item in sortOptions" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
          <table class="attTable">
            <tr>
              <th>{{ lang('Student Name') }}</th>
              <th>
                <span v-if="bundleAttendance === false">{{ lang('Attendance') }}</span
                ><br />
                <el-select
                  :placeholder="lang('Select Attendance For All')"
                  v-model="studentCheck"
                  @change="selectedAttendance()"
                  class=""
                  v-if="selectallStudent === false"
                >
                  <el-option v-for="itemCheckList in checkListSelect" :key="itemCheckList" :label="lang(itemCheckList)" :value="itemCheckList"> </el-option>
                </el-select>
              </th>
              <th>{{ lang('Remarks') }}</th>
            </tr>
            <tr v-for="(item, i) in studentList" ref="studentList_Update" :key="item.Student_ID + item.markingStatus">
              <td style="display: none"><input type="text" class="form-control" :value="item.Index_No" ref="studentIndexNo" /></td>

              <td style="display: none">{{ item.checked }}</td>
              <td>
                <label class="lblStudentName">{{ item.Student_Name }}</label>
              </td>

              <td class="">
                <el-select
                  ref="studentCheckList"
                  :placeholder="lang('Select')"
                  v-model="item.markingStatus"
                  @change="e => AttendanceByStudent(e, item)"
                  :class="[
                    { attend: item.markingStatus === 'Present' },
                    { late: item.markingStatus === 'Late' },
                    { absent: item.markingStatus === 'Absent' },
                    { sick: item.markingStatus === 'Sick' },
                    { holiday: item.markingStatus === 'On Holiday' },
                    { home: item.markingStatus === 'Sent Home' },
                  ]"
                >
                  <el-option v-for="itemCheckList in checkListSelect" :key="itemCheckList" :label="lang(itemCheckList)" :value="itemCheckList"> </el-option>
                </el-select>

                <div v-if="item.tempIn" style="margin-top: 5px">Temperature reading: {{ item.tempIn }}</div>
                <div v-if="item.tempIn">Time In: {{ item.timeIn }}</div>
                <div v-if="item.timeOut">Time Out: {{ item.timeOut }}</div>
              </td>
              <td>
                <input type="text" class="form-control" v-model="item.remarks" ref="studentRemark" />
              </td>
            </tr>
          </table>
        </div>
        <div class="text-center form-group col-lg-12" style="margin-top: 20px" v-if="studentList.length > 0">
          <button type="button" class="btn btn-primary float-right" v-on:click="Save">{{ lang('Save') }}</button>
        </div>
      </div>
      <b-modal size="lg" :title="lang('Thermal Scanner Import')" ok-only ok-variant="secondary" hide-footer ref="tempImportModal">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <textarea rows="4" v-model="tempDeviceOutput" class="taTempImport"> </textarea>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 tempImportButtonArea">
          <button v-on:click="tempImportSave()" class="btn btn-primary waves-effect waves-light m-r-10">
            {{ lang('Import') }}
          </button>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import moment from 'moment'
import { lang } from '../locale/index'
import GlobalFn from '../components/GlobalFn'
import Cookies from 'js-cookie'
import configAdmin from '@/config/configAdmin'
import { checkIsMiddleton } from '@/helper/util_custom'

export default {
  name: 'AttendanceList',
  data() {
    return {
      checkListSelect: configAdmin.attendanceOptions,
      ddlClassList: [],
      ddlClass: '',
      studentList: [],
      studentClass: [],
      studentCheck: [],
      selectedStudent: [],
      selectallStudent: false,
      bundleAttendance: false,
      hideStudentList: false,
      tempDeviceOutput: '',
      sortOptionsSelected: '',
      sortOptions: ['Student Name'],
      selectedDate: '',
      schID: '',
      backdatePeriod: 0,
      inputAdvanceClassAttendanceFromToDatePickerOptions: {
        disabledDate: time => {
          let today = new Date()
          let yesterday = new Date()
          yesterday.setDate(today.getDate() - this.backdatePeriod)
          return !(time <= today && yesterday <= time)
        },
      },
    }
  },
  async created() {
    this.schID = Cookies.get('schoolSession')
    await this.bindClasses()
    await this.getBackdateAttendancePeriod()
  },
  async mounted() {
    if (checkIsMiddleton()) {
      this.checkListSelect = configAdmin.misAttendanceOptions
    }
  },
  computed: {},
  components: {
    GlobalFn,
  },
  methods: {
    lang,
    showBundleAttendance(item) {
      this.selectallStudent = false
      const isCheck = this.studentList.find(m => m.checked === true)
      if (isCheck) {
        this.bundleAttendance = true
      } else {
        this.bundleAttendance = false
      }
    },
    checkAllStudent(e) {
      if (this.selectallStudent === true) {
        this.bundleAttendance = true
        this.studentList.forEach(m => {
          m.checked = true
        })
      } else {
        this.bundleAttendance = false

        this.studentList.forEach(m => {
          m.checked = false
        })
      }
    },
    selectedAttendance() {
      this.studentList.forEach(m => {
        m.markingStatus = this.studentCheck
      })
    },
    AttendanceByStudent(value, item) {
      item.markingStatus = value
      this.$forceUpdate()
    },
    async bindClasses() {
      try {
        const response = await DataSource.shared.getAttendanceClassWithMode('GroupClasName')
        if (response) {
          this.class = response.dsGroupClass.Table
          this.class.forEach(m => {
            this.ddlClassList.push(m)
          })
        }
      } catch (e) {
        this.results = e
      }
    },

    async getBackdateAttendancePeriod() {
      try {
        const response = await DataSource.shared.getRoleConfigurationByUSRID('BackdateAttendancePeriod')
        if (response) {
          this.backdatePeriod = Number(response.Table[0].BackdateAttendancePeriod != null ? response.Table[0].BackdateAttendancePeriod : 0)
        }
      } catch (e) {
        this.results = e
      }
    },

    async Load() {
      try {
        this.sortOptionsSelected = ''
        if (this.selectedDate === '') {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please select date'),
          })
        } else if (this.ddlClass === '') {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please select class'),
          })
        } else {
          this.$vs.loading()
          const response = await DataSource.shared.LoadAttendanceListWithDateMode(this.ddlClass, 'GroupClasName', this.selectedDate)
          if (response) {
            if (response.code === '2') {
              this.studentList = []
              this.hideStudentList = true
            } else if (response.code === '99') {
              this.$notify.error({
                title: lang('Error'),
                message: lang('Error! Please try again later'),
              })
            } else {
              this.studentList.forEach(m => {
                m.checked = false
              })
              this.studentList = response.Table

              this.studentListResponse = response.Table
            }
          }
          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async Save() {
      this.$vs.loading()
      try {
        let attendanceList = []

        this.$refs.studentList_Update.forEach((m, index) => {
          let status = ''

          if (
            this.$refs.studentCheckList[index].value === undefined ||
            this.$refs.studentCheckList[index].value === null ||
            this.$refs.studentCheckList[index].value === ''
          ) {
            status = ''
          } else {
            status = this.$refs.studentCheckList[index].value
          }

          let attendanceDetials = {
            status: status,
            remark: this.$refs.studentRemark[index].value,
          }

          let attendanceListTemp = {
            studentIndexNo: this.$refs.studentIndexNo[index].value,
            attDetails: attendanceDetials,
          }
          attendanceList.push(attendanceListTemp)
        })

        if (attendanceList.length < 1) {
          this.$notify.error({
            title: lang('Require'),
            message: lang('Please at least tick at least one row to update'),
          })
        } else {
          const response = await DataSource.shared.updateAttendanceListWithDateMode(JSON.stringify(attendanceList), this.selectedDate)
          if (response) {
            if (response.code === '1') {
              this.$notify({
                title: lang('Success'),
                message: lang('Successfully saved'),
                type: 'success',
              })
              this.Load()

              this.selectallStudent = false
              this.studentCheck = ''
            } else {
              this.$notify.error({
                title: lang('Error'),
                message: lang('Error! Please try again later'),
              })
              window.location.replace('/backdateattendance')
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async checkAll() {
      try {
        if (this.$refs.checkAllBox.checked == true) {
          this.$refs.studentCheckList.forEach(m => {
            m.checked = true
          })
        } else {
          this.$refs.studentCheckList.forEach(m => {
            m.checked = false
          })
        }
      } catch (e) {
        this.results = e
      }
    },

    changeSort() {
      if (this.sortOptionsSelected === 'Student Name') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'Student_Name', 'asc')
      }
    },
    clearData() {
      this.studentList = []
      this.ddlClass = ''
    },
  },
}
</script>
<style scoped>
.attTable {
  width: 100%;
  margin-top: 20px;
}

.attTable td,
.attTable th,
.attTable label {
  text-align: center;
  padding: 10px;
}

.attTable tr:nth-child(even) {
  background: #fff;
}

.ddlClass {
  display: inline;
  width: auto;
}

.lblClass {
  display: inline !important;
  padding: 20px;
}

input[type='checkbox'] {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 5px;
  border: 2px solid #555;
}

.searchingArea {
  text-align: left;
}

.checkbox_wrapper {
  min-width: 100%;
}

.lblCheckBox {
  width: 100%;
}

.attendance-search .el-select {
  margin-left: 10px !important;
}

.lblStudentName {
  font-weight: normal !important;
}

.divSortBy {
  text-align: right;
}
.divSortBy label {
  display: inline !important;
  margin-right: 10px;
}
</style>
